// extracted by mini-css-extract-plugin
export default {"root":"BundleHero-root","heading":"BundleHero-heading","highlighted":"BundleHero-highlighted","body":"BundleHero-body","ctaWrap":"BundleHero-ctaWrap"};